import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import vegdetail from './views/vegdetail.vue'
// import App from './App.vue'

import whyeatseasonally from './views/whyeatseasonally.vue'
import about from './views/about.vue'
import gettheapp from './views/gettheapp.vue'
import newsletter from './views/newsletter.vue'
import press from './views/press.vue'
import mediakit from './views/mediakit.vue'
import NotFound from './views/NotFound.vue'
// import { listStates } from "./components/staticFiles/stateLookup.js"
// import cards from './components/staticFiles/sfg-35.json'
// import { listmonths } from './components/staticFiles/months.js'

Vue.use(Router)

// function isValid (val, array ) {
//     return (array.find( ({ desc }) => desc == val.replace(/ /g,"-").toLowerCase() ) || val == 'Select a State' || val == 'Any Month') ? true : false
// }

// function isValidCards (val) {
//     return (cards.find( ({ name }) => name == val.replace(/ /g,"-").toLowerCase() ) || val == 'Any Produce') ? true : false
// }

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            props:true
        },
        {
            path: '/state/:state',
            name: 'selectstate',
            component: Home,
            props:true,

            // beforeEnter: (to, from, next) => {
            //     if (!isValid(to.params.state, listStates) && isValid(to.params.month, listmonths) && isValidCards(to.params.card)) {
            //         next({ name: 'not-found' });
            //     }
            //     next();
            // }            
        }, 
        {
            path: '/:state/:month',
            name: 'homestate',
            component: Home,
            props:true,
            // beforeEnter: (to, from, next) => {
            //     if (!isValid(to.params.state, listStates) || !isValid(to.params.month, listmonths) && isValidCards(to.params.card)) {
            //         next({ name: 'not-found' });
            //     }
            //     next();
            // }            
        },
        {
            path: '/veg/:card/:state',
            name: 'vegdetail',
            component: vegdetail,
            props:true,
            // beforeEnter: (to, from, next) => {
            //     if (!isValidCards(to.params.card) || !isValid(to.params.state, listStates) && isValid(to.params.month, listmonths)) {
            //         next({ name: 'not-found' });
            //     }
            //     next();
            // }             
        },

        {
            path: '/why-eat-seasonally',
            name: 'whyeatseasonally',
            component: whyeatseasonally
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },
        {
            path: '/download-app',
            name: 'gettheapp',
            component: gettheapp
        },
        {
            path: '/newsletter',
            name: 'newsletter',
            component: newsletter
        },
        {
            path: '/press',
            name: 'press',
            component: press
        },
        {
            path: '/media-kit',
            name: 'mediakit',
            component: mediakit
        },
        {
            path: '*',
            name: 'not-found',
            component: NotFound
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
      },



})

